import PropTypes from 'prop-types';
import React from 'react';

import FormControlLabel from '@glass/web/components/base/FormControlLabel';
import usePrettyReduxFormLabel from '@glass/web/modules/controls/usePrettyReduxFormLabel';

import Switch from '@glass/shared/components/muiWrappers/Switch';

function SwitchWithLabel(props) {
  const label = usePrettyReduxFormLabel(props);
  return <FormControlLabel control={<Switch {...props} color="secondary" />} label={label} />;
}

SwitchWithLabel.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

export default SwitchWithLabel;
